import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getQualifications from './getQualifications';

const actions = createActions({
  USER: {
    UPDATE_QUALIFICATION: (qualification, existingAttachments, files) => ({ qualification, existingAttachments, files }),
    API: {
      UPDATE_QUALIFICATION: apiResourceActionCreator('qualifications')
    }
  }
})

export const apiAction = (authToken, qualificationId, formData) => commonApiActions.authenticated.putFormData(`${USER_RESOURCE_ENDPOINT(RESOURCES.Qualification)}/${qualificationId}`, authToken, formData, actions.user.api.updateQualification)

export function* updateQualification(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    const { qualification, existingAttachments, files } = action.payload
    const formData = {
      data: {
        qualification,
        existingAttachments
      },
      file: files
    }
    yield put(apiAction(authToken, qualification.id, formData));

    const result = yield apiActionResult(actions.user.api.updateQualification);
    if (result.success) {
      yield put(getQualifications.action.user.getQualifications());
      yield put(push({ pathname: routes.app.professionalProfile.root }))
    }
  }
}

const configuration = {
  name: 'updateQualification',
  action: actions,
  sagas: updateQualification,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      isUpdating: false
    }),
    failed: (state, action) => ({
      ...state,
      isUpdating: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/updateQualification.js